<template>
  <n-space class="bg-info"></n-space>
</template>

<script>
import { computed, defineComponent, h, onMounted, ref } from '@vue/runtime-core'
import { NSpace, useNotification } from 'naive-ui'
import { useStore } from 'vuex'

export default defineComponent({
  components: {
    NSpace
  },
  setup () {
    const store = useStore()
    const notification = useNotification()

    const notificationContent = ref(null)
    const isConnected = ref(null)
    const statusList = ref([])

    const user = computed(() => store.getters['users/_user'])

    const updateConnectionStatus = status => {
      if (!user.value) return false // no further execution if no user is logged in

      isConnected.value = window.navigator.onLine
      // update status list
      statusList.value.push(status)

      switch (isConnected.value) {
        case true:
          // check if previously disconnected
          if (statusList.value[statusList.value.length - 2] === 'offline') location.reload()
          break

        case false:
          notificationContent.value = {
            content: 'Connection Status',
            meta: () => h('b', { class: 'text-danger' }, 'NO INTERNET CONNECTION'),
            closable: false
          }
          notification.error(notificationContent.value)
          break
      }
    }

    onMounted(() => {
      const ConnectionStatus = window.navigator.onLine ? 'online' : 'offline'
      // initiate notification
      updateConnectionStatus(ConnectionStatus)

      // watch connection status
      window.addEventListener('online', () => updateConnectionStatus('online'))
      window.addEventListener('offline', () => updateConnectionStatus('offline'))
    })

    return {
      isConnected
    }
  }
})
</script>
